import { render } from "./TeacherCalendar.vue?vue&type=template&id=23024eea&scoped=true"
import script from "./TeacherCalendar.vue?vue&type=script&lang=js"
export * from "./TeacherCalendar.vue?vue&type=script&lang=js"

import "./TeacherCalendar.vue?vue&type=style&index=0&id=23024eea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23024eea"]])

export default __exports__